import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

const STATS = [
  { n: '1M+', l: 'Patients Served' },
  { n: '100%', l: 'Pathologist-Verified' },
  { n: '4.5 ★', l: 'Users Rating' },
  { n: '60 min', l: 'Trustian Arrival' },
  { n: '13', l: 'Cities Active' },
];

const StatsBand = () => (
  <Box sx={{ bgcolor: 'var(--parchment)', py: { xs: 5, md: 8 } }}>
    <Container maxWidth="xl" sx={{ maxWidth: 1300, px: { xs: 2, md: 4 } }}>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: {
            xs: 'repeat(2, 1fr)',
            sm: 'repeat(3, 1fr)',
            md: 'repeat(5, 1fr)',
          },
          width: '100%',
          rowGap: { xs: 3, md: 0 },
        }}
      >
        {STATS.map((s, i) => (
          <Box
            key={s.l}
            sx={{
              textAlign: 'center',
              px: { xs: 1.5, md: 2 },
              py: { xs: 1, md: 2 },
              borderRight: {
                xs: 'none',
                md: i < STATS.length - 1 ? '1px solid var(--border)' : 'none',
              },
            }}
          >
            <Typography
              className="serif"
              sx={{
                fontSize: { xs: 30, sm: 36, md: 42, lg: 48 },
                fontWeight: 500,
                color: 'var(--ink)',
                lineHeight: 1,
                mb: 1,
              }}
            >
              {s.n}
            </Typography>
            <Typography
              component="span"
              sx={{
                fontSize: { xs: 10, md: 11 },
                fontWeight: 700,
                color: 'var(--stone)',
                letterSpacing: '0.14em',
                textTransform: 'uppercase',
                lineHeight: 1,
              }}
            >
              {s.l}
            </Typography>
          </Box>
        ))}
      </Box>
    </Container>
  </Box>
);

export default StatsBand;
